import { graphql } from "gql";

const ADMIN_CREATE_TAG_MUTATION = graphql(`
  mutation AdminCreateTag($input: AdminCreateTagInput!) {
    adminCreateTag(input: $input) {
      ...Tag
    }
  }
`);

export default ADMIN_CREATE_TAG_MUTATION;
